import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffLegalRepresentativeRequest,
  StaffLegalRepresentativeResponse,
} from "../model/legal-representative.model";

@Injectable({ providedIn: "root" })
export class StaffLegalRepresentativesService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) organizationBasePath: string,
  ) {
    this.url = `${organizationBasePath.replace(/\/$/, "")}/api/v1/legal-representatives`;
  }

  list(filters?: {
    companyId?: number;
    status?: string;
  }): Observable<StaffLegalRepresentativeResponse[]> {
    let params = new HttpParams();
    if (filters?.companyId != null)
      params = params.set("companyId", filters.companyId);
    if (filters?.status) params = params.set("status", filters.status);
    return this.http.get<StaffLegalRepresentativeResponse[]>(this.url, {
      params,
    });
  }

  getById(id: number): Observable<StaffLegalRepresentativeResponse> {
    return this.http.get<StaffLegalRepresentativeResponse>(`${this.url}/${id}`);
  }

  create(
    request: StaffLegalRepresentativeRequest,
  ): Observable<StaffLegalRepresentativeResponse> {
    return this.http.post<StaffLegalRepresentativeResponse>(this.url, request);
  }

  update(
    id: number,
    request: StaffLegalRepresentativeRequest,
  ): Observable<StaffLegalRepresentativeResponse> {
    return this.http.put<StaffLegalRepresentativeResponse>(
      `${this.url}/${id}`,
      request,
    );
  }

  setStatus(
    id: number,
    active: boolean,
  ): Observable<StaffLegalRepresentativeResponse> {
    return this.http.patch<StaffLegalRepresentativeResponse>(
      `${this.url}/${id}/status`,
      { active },
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
